import type { PhotoCardType } from '../types/PhotoCardType';

/**
 * 포토카드 뱃지 우선순위 순서로 정렬 후 반환
 * @param photoCard 포토카드
 * @returns 포토카드 뱃지 배열
 */
export const getPhotoCardBadges = (photoCard: PhotoCardType): string[] => {
  const badges: string[] = [];

  if (photoCard?.distributors && Array.isArray(photoCard.distributors)) {
    badges.push(...photoCard.distributors.map((distributor) => distributor.name));
  }
  if (photoCard?.tags && Array.isArray(photoCard.tags)) {
    badges.push(...photoCard.tags.map((tag) => tag.name));
  }
  if (photoCard?.meta?.polaroid) {
    badges.push('POLAROID');
  }
  if (photoCard?.meta?.unit) {
    badges.push('UNIT');
  }
  return badges;
};
